export default __webpack_public_path__ + "static/media/cross.81ed371c.svg";